import { ApiService } from "Services/ApiService";
import { EcomConfigPublicDto } from "Types/EcomConfigPublicType";
import { ResultsDTO } from "Types/ResultsDTO";

export const EcomConfigPublicApiSlice = ApiService.injectEndpoints({
    endpoints: (builder) => ({
        getPublicEcomConfig: builder.query<EcomConfigPublicDto, string>({
            query: (plant) => ({
                url: `ecomconfig/public/${plant}`,
            }),
            transformResponse: (response: ResultsDTO<EcomConfigPublicDto>) =>
                response.results,
            providesTags: [{ type: "Configuration", id: "PUBLIC" }],
        }),
    }),
});

export const { useGetPublicEcomConfigQuery } = EcomConfigPublicApiSlice;
